// Segments
export const ENG_SEGMENT_LIST_ACTION = "ENG_SEGMENT_LIST_ACTION";
export const ENG_SEGMENT_LIST_LOADING = "ENG_SEGMENT_LIST_LOADING";
export const ENG_SEGMENT_LIST_SUCCESS = "ENG_SEGMENT_LIST_SUCCESS";
export const ENG_SEGMENT_LIST_ERROR = "ENG_SEGMENT_LIST_ERROR";

export const ENG_SEGMENT_CREATE_ACTION = "ENG_SEGMENT_CREATE_ACTION";
export const ENG_SEGMENT_CREATE_LOADING = "ENG_SEGMENT_CREATE_LOADING";
export const ENG_SEGMENT_CREATE_SUCCESS = "ENG_SEGMENT_CREATE_SUCCESS";
export const ENG_SEGMENT_CREATE_ERROR = "ENG_SEGMENT_CREATE_ERROR";

export const ENG_SEGMENT_PREVIEW_ACTION = "ENG_SEGMENT_PREVIEW_ACTION";
export const ENG_SEGMENT_PREVIEW_LOADING = "ENG_SEGMENT_PREVIEW_LOADING";
export const ENG_SEGMENT_PREVIEW_SUCCESS = "ENG_SEGMENT_PREVIEW_SUCCESS";
export const ENG_SEGMENT_PREVIEW_ERROR = "ENG_SEGMENT_PREVIEW_ERROR";

// Templates
export const ENG_TEMPLATE_LIST_ACTION = "ENG_TEMPLATE_LIST_ACTION";
export const ENG_TEMPLATE_LIST_LOADING = "ENG_TEMPLATE_LIST_LOADING";
export const ENG_TEMPLATE_LIST_SUCCESS = "ENG_TEMPLATE_LIST_SUCCESS";
export const ENG_TEMPLATE_LIST_ERROR = "ENG_TEMPLATE_LIST_ERROR";

// Campaigns
export const ENG_CAMPAIGN_LIST_ACTION = "ENG_CAMPAIGN_LIST_ACTION";
export const ENG_CAMPAIGN_LIST_LOADING = "ENG_CAMPAIGN_LIST_LOADING";
export const ENG_CAMPAIGN_LIST_SUCCESS = "ENG_CAMPAIGN_LIST_SUCCESS";
export const ENG_CAMPAIGN_LIST_ERROR = "ENG_CAMPAIGN_LIST_ERROR";

export const ENG_CAMPAIGN_CREATE_ACTION = "ENG_CAMPAIGN_CREATE_ACTION";
export const ENG_CAMPAIGN_CREATE_LOADING = "ENG_CAMPAIGN_CREATE_LOADING";
export const ENG_CAMPAIGN_CREATE_SUCCESS = "ENG_CAMPAIGN_CREATE_SUCCESS";
export const ENG_CAMPAIGN_CREATE_ERROR = "ENG_CAMPAIGN_CREATE_ERROR";

export const ENG_CAMPAIGN_LAUNCH_ACTION = "ENG_CAMPAIGN_LAUNCH_ACTION";
export const ENG_CAMPAIGN_LAUNCH_LOADING = "ENG_CAMPAIGN_LAUNCH_LOADING";
export const ENG_CAMPAIGN_LAUNCH_SUCCESS = "ENG_CAMPAIGN_LAUNCH_SUCCESS";
export const ENG_CAMPAIGN_LAUNCH_ERROR = "ENG_CAMPAIGN_LAUNCH_ERROR";

export const ENG_CAMPAIGN_PAUSE_ACTION = "ENG_CAMPAIGN_PAUSE_ACTION";
export const ENG_CAMPAIGN_PAUSE_LOADING = "ENG_CAMPAIGN_PAUSE_LOADING";
export const ENG_CAMPAIGN_PAUSE_SUCCESS = "ENG_CAMPAIGN_PAUSE_SUCCESS";
export const ENG_CAMPAIGN_PAUSE_ERROR = "ENG_CAMPAIGN_PAUSE_ERROR";

export const ENG_CAMPAIGN_CANCEL_ACTION = "ENG_CAMPAIGN_CANCEL_ACTION";
export const ENG_CAMPAIGN_CANCEL_LOADING = "ENG_CAMPAIGN_CANCEL_LOADING";
export const ENG_CAMPAIGN_CANCEL_SUCCESS = "ENG_CAMPAIGN_CANCEL_SUCCESS";
export const ENG_CAMPAIGN_CANCEL_ERROR = "ENG_CAMPAIGN_CANCEL_ERROR";

export const ENG_CAMPAIGN_ANALYTICS_ACTION = "ENG_CAMPAIGN_ANALYTICS_ACTION";
export const ENG_CAMPAIGN_ANALYTICS_LOADING = "ENG_CAMPAIGN_ANALYTICS_LOADING";
export const ENG_CAMPAIGN_ANALYTICS_SUCCESS = "ENG_CAMPAIGN_ANALYTICS_SUCCESS";
export const ENG_CAMPAIGN_ANALYTICS_ERROR = "ENG_CAMPAIGN_ANALYTICS_ERROR";

export const ENG_RESET_MUTATION = "ENG_RESET_MUTATION";
